<template>
  <div class="uncharted">Sorry this page is currently unavailable or doesn't exist.</div>
</template>

<script>
export default {
  name: "uncharted"
}
</script>
